<template>
  <div class="bet-header">
    <div class="bet-header-top text-cut text-center">
      <p class="bet-id bet-id-1">
        {{ bet.bets[0].idDisplay }}
      </p>
      <p class="bet-name text-upper text-cut">
        {{ bet.bets[0].nameShort }}
      </p>
      <p
        class="bet-id bet-id-2 font-italic"
        v-if="bet.bets[1]">
        {{ bet.bets[1].idDisplay }}
      </p>
    </div>
    <div class="bet-header-bottom text-center text-upper">
      <p
        class="outcome-name"
        :class="`outcome-${bet.bets[0].outcomes.length}`"
        v-for="outcome in bet.bets[0].outcomes"
        :key="outcome.id">
        {{ outcome.nameShort }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SportHeaderBetSpecial',
  props: {
    bet: {
      required: true,
      type: Object,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../assets/style/variables";

.bet-header {
  overflow: hidden;
  height: 5vh;
}

.bet-header-top,
.bet-header-bottom {
  position: relative;
  float: left;
  width: 100%;
}

.bet-header-top {
  height: $sport-header-bet-top-height;
  line-height: $sport-header-bet-top-height;
  background-color: $sport-header-bet-top-color-back;
  font-size: 0.6875rem;

  .bet-id {
    position: absolute;
    top: 0;
    bottom: 0;
    width: $sport-header-bet-top-id-width;
    color: $sport-header-bet-top-id-color;
    background-color: $sport-header-bet-top-id-color-back;
    font-size: 0.8125rem;
    overflow: hidden;
  }

  .bet-id-1 {
    left: 0;
    padding-left: 2px;
    border-top-right-radius: $sport-header-bet-top-id-border-radius;
    border-bottom-right-radius: $sport-header-bet-top-id-border-radius;
    &:after {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      width: 2px;
      background-color: $sport-header-bet-bottom-color-back;
    }
  }

  .bet-id-2 {
    right: 0;
    padding-right: 2px;
    border-top-left-radius: $sport-header-bet-top-id-border-radius;
    border-bottom-left-radius: $sport-header-bet-top-id-border-radius;
    background-color: $color-important;
  }

  .bet-name {
    height: 100%;
    padding: 0 $sport-header-bet-top-id-width + 0.2083vw;
  }
}

.bet-header-bottom {
  height: $sport-header-bet-bottom-height;
  line-height: $sport-header-bet-bottom-height;
  font-size: 0.62rem;
  @if $sport-header-gradient == false {
    background-color: $sport-header-bet-bottom-color-back;
  }

  .outcome-name {
    float: left;
    width: 50%;
    height: 100%;

    &.outcome-3 { width: 33.33%; }
    &.outcome-4 { width: 25%; }
    &.outcome-5 { width: 20%; }
  }
}
</style>
